<div class="global-notifications-container" [ngClass]="{'show-header': notifications.length > 3}">
  <div class="notifications-header" *ngIf="notifications.length > 3">
    <div class="d-flex align-items-center gap-2">
      <h4>{{ 'notifications' | t }}</h4>
      <div class="counter">
        <span> {{ notifications.length }} </span>
      </div>
    </div>
    <button type="button" class="btn remove-all-button" aria-label="Close" (click)="removeAll()">
      <nb-icon icon="cross" pack="icomoon"></nb-icon>
      <span>{{ 'clear_all' | t }}</span>
    </button>
  </div>

  <div class="scroll-container">
    <div class="scroll-wrapper">
      <!-- Tymczasowe powiadomienia (non-persistent) - zawsze na górze -->
      <ng-container *ngFor="let notification of nonStackedNotifications; trackBy: trackByNotification">
        <ng-container *ngIf="!notification.isPersistent">
          <!-- Grupa powiadomienia z jego stackiem -->
          <div class="notification-group" [ngClass]="{'has-stack': hasStackedNotificationsForType(notification.type, false)}">
            <!-- Główne widoczne powiadomienie tymczasowe danego typu -->
            <div
              class="global-notification main-notification"
              [ngClass]="{
                 'success': notification.type === 'success',
                 'danger': notification.type === 'danger',
                 'warning': notification.type === 'warning',
                 'info': notification.type === 'info',
                 'has-stack': hasStackedNotificationsForType(notification.type, false),
                 'expanded': isStackExpanded(notification.type, false)
               }"
              [style.z-index]="1000"
              [@notificationAnimation]
              (mouseenter)="pauseNotification(notification)"
              (mouseleave)="resumeNotification(notification)">
              <div class="notification-content">
                <div class="notification-header">
                  <div class="notification-icon">
                    <nb-icon icon="{{ checkNotificationIcon(notification.type) }}" pack="icomoon"></nb-icon>
                  </div>
                  <button type="button" class="btn rounded-circle close-button" aria-label="Close" (click)="remove(notification.id)">
                    <nb-icon icon="cross" pack="icomoon"></nb-icon>
                  </button>
                </div>
                <div class="notification-message">
                  <ng-container *ngIf="notification.translate; else notTranslated">
                    <p class="message">{{ notification.message | translate }}</p>
                  </ng-container>
                  <ng-template #notTranslated>
                    <p class="message">{{ notification.message }}</p>
                  </ng-template>
                </div>
              </div>

              <!-- Progress bar tylko dla głównego (widocznego) powiadomienia tymczasowego -->
              <div
                class="progress-bar"
                [ngClass]="notification.type"
                [@progressAnimation]="{
                   value: notification.animationState || 'start',
                   params: { duration: notification.duration || 10000 }
                 }"></div>
            </div>

            <!-- Container dla stackowanych tymczasowych powiadomień tego typu -->
            <div
              class="type-stacked-notifications-container"
              *ngIf="hasStackedNotificationsForType(notification.type, false)"
              [ngClass]="{'expanded': isStackExpanded(notification.type, false)}">
              <!-- Przycisk do rozwijania stacka - widoczny tylko gdy stack jest zwinięty -->
              <button
                type="button"
                class="btn expand-type-stack-button"
                (click)="toggleStackExpansion(notification.type, false)"
                *ngIf="!isStackExpanded(notification.type, false)">
                <nb-icon [icon]="'chevron-right'" pack="icomoon"></nb-icon>
                <span>{{ ('expand' | t) + ' (+' + getStackedCountForType(notification.type, false) + ')' }}</span>
              </button>

              <!-- Lista stackowanych tymczasowych powiadomień danego typu -->
              <div
                *ngFor="let stackedNotification of getStackedNotificationsForType(notification.type, false); trackBy: trackByNotification"
                class="global-notification stacked"
                [ngClass]="{
                   'success': stackedNotification.type === 'success',
                   'danger': stackedNotification.type === 'danger',
                   'warning': stackedNotification.type === 'warning',
                   'info': stackedNotification.type === 'info',
                   'expanded': isStackExpanded(stackedNotification.type, false)
                 }"
                [style.z-index]="isStackExpanded(stackedNotification.type, false) ? (100 - (stackedNotification.stackIndex ?? 0)) : (100 - (stackedNotification.stackIndex ?? 0))"
                [style.transform]="!isStackExpanded(stackedNotification.type, false) ? getStackedNotificationTransform(stackedNotification) : null">
                <div class="notification-content">
                  <div class="notification-header">
                    <div class="notification-icon">
                      <nb-icon icon="{{ checkNotificationIcon(stackedNotification.type) }}" pack="icomoon"></nb-icon>
                    </div>
                    <button type="button" class="btn rounded-circle close-button" aria-label="Close" (click)="remove(stackedNotification.id)">
                      <nb-icon icon="cross" pack="icomoon"></nb-icon>
                    </button>
                  </div>
                  <div class="notification-message">
                    <ng-container *ngIf="stackedNotification.translate; else notTranslated">
                      <p class="message">{{ stackedNotification.message | translate }}</p>
                    </ng-container>
                    <ng-template #notTranslated>
                      <p class="message">{{ stackedNotification.message }}</p>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>

      <!-- Stałe powiadomienia (persistent) z ich stackami -->
      <ng-container *ngFor="let notification of nonStackedNotifications; trackBy: trackByNotification">
        <ng-container *ngIf="notification.isPersistent">
          <!-- Grupa powiadomienia z jego stackiem -->
          <div class="notification-group" [ngClass]="{'has-stack': hasStackedNotificationsForType(notification.type, true)}">
            <!-- Główne widoczne powiadomienie danego typu -->
            <div
              class="global-notification main-notification"
              [ngClass]="{
                 'success': notification.type === 'success',
                 'danger': notification.type === 'danger',
                 'warning': notification.type === 'warning',
                 'info': notification.type === 'info',
                 'has-stack': hasStackedNotificationsForType(notification.type, true),
                 'expanded': isStackExpanded(notification.type, true)
               }"
              [style.z-index]="110"
              [@notificationAnimation]
              (mouseenter)="pauseNotification(notification)"
              (mouseleave)="resumeNotification(notification)">
              <div class="notification-content">
                <div class="notification-header">
                  <div class="d-flex align-items-center gap-2">
                    <div class="notification-icon">
                      <nb-icon icon="{{ checkNotificationIcon(notification.type) }}" pack="icomoon"></nb-icon>
                    </div>
                    <span class="created-at"> {{ (notification.created_at | date: 'd-MM-yyyy HH:mm') | changeDateFormat: 'at': 'normal' }} </span>
                  </div>
                  <button type="button" class="btn rounded-circle close-button" aria-label="Close" (click)="remove(notification.id)">
                    <nb-icon icon="cross" pack="icomoon"></nb-icon>
                  </button>
                </div>
                <div class="notification-message">
                  <ng-container *ngIf="notification.translate; else notTranslated">
                    <p class="message">{{ notification.message | translate }}</p>
                  </ng-container>
                  <ng-template #notTranslated>
                    <p class="message">{{ notification.message }}</p>
                  </ng-template>
                </div>
              </div>
              <div class="notification-button" *ngIf="notification?.link">
                <app-secondary-button
                  [text]="'details'"
                  [largeButton]="false"
                  [backgroundColor]="'grey'"
                  [secondIcon]="'external-link-bold'"
                  (emitAction)="goToLink(notification?.link || '')">
                </app-secondary-button>
              </div>
            </div>

            <!-- Container dla stackowanych powiadomień tego typu -->
            <div
              class="type-stacked-notifications-container"
              *ngIf="hasStackedNotificationsForType(notification.type, true)"
              [ngClass]="{'expanded': isStackExpanded(notification.type, true)}">
              <!-- Przycisk do rozwijania stacka - widoczny tylko gdy stack jest zwinięty -->
              <button
                type="button"
                class="btn expand-type-stack-button"
                (click)="toggleStackExpansion(notification.type, true)"
                *ngIf="!isStackExpanded(notification.type, true)">
                <nb-icon [icon]="'chevron-right'" pack="icomoon"></nb-icon>
                <span>{{ ('expand' | t) + ' (+' + getStackedCountForType(notification.type, true) + ')' }}</span>
              </button>

              <!-- Lista stackowanych powiadomień danego typu -->
              <div
                *ngFor="let stackedNotification of getStackedNotificationsForType(notification.type, true); trackBy: trackByNotification"
                class="global-notification stacked"
                [ngClass]="{
                   'success': stackedNotification.type === 'success',
                   'danger': stackedNotification.type === 'danger',
                   'warning': stackedNotification.type === 'warning',
                   'info': stackedNotification.type === 'info',
                   'expanded': isStackExpanded(stackedNotification.type, true)
                 }"
                [style.z-index]="isStackExpanded(stackedNotification.type, true) ? (100 - (stackedNotification.stackIndex ?? 0)) : (100 - (stackedNotification.stackIndex ?? 0))"
                [style.transform]="!isStackExpanded(stackedNotification.type, true) ? getStackedNotificationTransform(stackedNotification) : null">
                <div class="notification-content">
                  <div class="notification-header">
                    <div class="d-flex align-items-center gap-2">
                      <div class="notification-icon">
                        <nb-icon icon="{{ checkNotificationIcon(stackedNotification.type) }}" pack="icomoon"></nb-icon>
                      </div>
                      <span class="created-at"> {{ (stackedNotification.created_at | date: 'd-MM-yyyy HH:mm') | changeDateFormat: 'at': 'normal' }} </span>
                    </div>
                    <button type="button" class="btn rounded-circle close-button" aria-label="Close" (click)="remove(stackedNotification.id)">
                      <nb-icon icon="cross" pack="icomoon"></nb-icon>
                    </button>
                  </div>
                  <div class="notification-message">
                    <ng-container *ngIf="stackedNotification.translate; else notTranslated">
                      <p class="message">{{ stackedNotification.message | translate }}</p>
                    </ng-container>
                    <ng-template #notTranslated>
                      <p class="message">{{ stackedNotification.message }}</p>
                    </ng-template>
                  </div>
                </div>
                <div class="notification-button" *ngIf="stackedNotification?.link && isStackExpanded(stackedNotification.type, true)">
                  <app-secondary-button
                    [text]="'details'"
                    [largeButton]="false"
                    [backgroundColor]="'grey'"
                    [secondIcon]="'external-link-bold'"
                    (emitAction)="goToLink(stackedNotification?.link || '')">
                  </app-secondary-button>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>
